import {
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import React from 'react';

const ListToggleButtonGroup = ({ label, name, value, onChange, list }) => {
  return (
    <Stack gap={1} direction="row" alignItems="center">
      <Typography variant="body2">{label}</Typography>
      <ToggleButtonGroup
        color="secondary"
        name={name}
        value={value}
        exclusive
        onChange={onChange}
        size="small"
        sx={{ height: 36 }}
      >
        {list.map(({ label: l, value: v }) => (
          <ToggleButton value={v} key={`${name}_${v}`}>
            {l}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};
export default ListToggleButtonGroup;
